
const MappingIcon = () => {

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_129_1568)">
    <path d="M13.3333 4.0013V12.0013M12 2.66797H4M12 13.3346H4M2.66666 12.0013V4.0013" stroke="#141B34" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14.6667 2.66732C14.6667 3.4037 14.0697 4.00065 13.3333 4.00065C12.597 4.00065 12 3.4037 12 2.66732C12 1.93094 12.597 1.33398 13.3333 1.33398C14.0697 1.33398 14.6667 1.93094 14.6667 2.66732Z" stroke="#141B34" stroke-width="1.5"/>
    <path d="M4 2.66732C4 3.4037 3.40304 4.00065 2.66667 4.00065C1.93029 4.00065 1.33333 3.4037 1.33333 2.66732C1.33333 1.93094 1.93029 1.33398 2.66667 1.33398C3.40304 1.33398 4 1.93094 4 2.66732Z" stroke="#141B34" stroke-width="1.5"/>
    <path d="M14.6667 13.3333C14.6667 14.0697 14.0697 14.6667 13.3333 14.6667C12.597 14.6667 12 14.0697 12 13.3333C12 12.597 12.597 12 13.3333 12C14.0697 12 14.6667 12.597 14.6667 13.3333Z" stroke="#141B34" stroke-width="1.5"/>
    <path d="M4 13.3333C4 14.0697 3.40304 14.6667 2.66667 14.6667C1.93029 14.6667 1.33333 14.0697 1.33333 13.3333C1.33333 12.597 1.93029 12 2.66667 12C3.40304 12 4 12.597 4 13.3333Z" stroke="#141B34" stroke-width="1.5"/>
    </g>
    <defs>
    <clipPath id="clip0_129_1568">
    <rect width="16" height="16" fill="white"/>
    </clipPath>
    </defs>
    </svg>
  );
};

export default MappingIcon;
